import { useAuth } from "../../context/AuthContext";

export function useCanLoadPortfolioEstimate(): boolean {
  const { isAuthenticated, userProfile } = useAuth();

  return (
    isAuthenticated &&
    userProfile?.emailVerified === true &&
    userProfile?.profile_completed === true
  );
}
